import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { css } from "@emotion/react";
import { useState } from "react";
import { MdLocalShipping } from "react-icons/md";

import { SchedulePickupBody } from "@megaron/fulfillment-contracts";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: SchedulePickupBody) => void;
};

const defaultValues = {
  name: "Megaron S.A.",
  phone: "609989359",
  email: "lukasz.stankiewicz@megaron.com.pl",
  street: "Pyrzycka",
  buildingNumber: "3 e,f",
  city: "Szczecin",
  postCode: "70-892",
  countryCode: "PL",
  comment: "Magazyn H2",
  officeHours: "7:30 - 16:00",
};

export const ScheduleCourierDialog = ({ isOpen, onClose, onConfirm }: Props) => {
  const [name, setName] = useState(defaultValues.name);
  const [phone, setPhone] = useState(defaultValues.phone);
  const [email, setEmail] = useState(defaultValues.email);
  const [street, setStreet] = useState(defaultValues.street);
  const [buildingNumber, setBuildingNumber] = useState(defaultValues.buildingNumber);
  const [city, setCity] = useState(defaultValues.city);
  const [postCode, setPostCode] = useState(defaultValues.postCode);
  const [countryCode, setCountryCode] = useState(defaultValues.countryCode);
  const [comment, setComment] = useState(defaultValues.comment);
  const [officeHours, setOfficeHours] = useState(defaultValues.officeHours);

  const handleSubmit = () => {
    onConfirm({
      name,
      phone,
      email,
      address: {
        street,
        buildingNumber,
        city,
        postCode,
        countryCode,
      },
      comment,
      officeHours,
    });
    onClose();
    setName(defaultValues.name);
    setPhone(defaultValues.phone);
    setEmail(defaultValues.email);
    setStreet(defaultValues.street);
    setBuildingNumber(defaultValues.buildingNumber);
    setCity(defaultValues.city);
    setPostCode(defaultValues.postCode);
    setCountryCode(defaultValues.countryCode);
    setComment(defaultValues.comment);
    setOfficeHours(defaultValues.officeHours);
  };

  if (!isOpen) return null;

  return (
    <Dialog
      header={
        <div css={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <MdLocalShipping />
          Zamów kuriera
        </div>
      }
      onClose={onClose}
      css={{ maxWidth: "600px" }}
    >
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem 0" }}>
        <TextField label="Nazwa" value={name} onChange={setName} autoFocus />
        <TextField label="Telefon" value={phone} onChange={setPhone} />
        <TextField label="Email" value={email} onChange={setEmail} inputElementProps={{ type: "email" }} />
        <div css={{ display: "flex", gap: "0.5rem" }}>
          <div css={{ flex: 2 }}>
            <TextField label="Ulica" value={street} onChange={setStreet} />
          </div>
          <div css={{ flex: 1 }}>
            <TextField label="Numer" value={buildingNumber} onChange={setBuildingNumber} />
          </div>
        </div>
        <div css={{ display: "flex", gap: "0.5rem" }}>
          <div css={{ flex: 2 }}>
            <TextField label="Miasto" value={city} onChange={setCity} />
          </div>
          <div css={{ flex: 1 }}>
            <TextField label="Kod pocztowy" value={postCode} onChange={setPostCode} />
          </div>
        </div>
        <TextField label="Kod kraju" value={countryCode} onChange={setCountryCode} />
        <TextField label="Godziny odbioru" value={officeHours} onChange={setOfficeHours} />
        <TextField label="Komentarz" value={comment} onChange={setComment} multiline />
      </div>
      <div css={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", marginTop: "1rem" }}>
        <Button variant="outline" onClick={onClose}>
          Anuluj
        </Button>
        <Button onClick={handleSubmit} icon={<MdLocalShipping />}>
          Zamów kuriera
        </Button>
      </div>
    </Dialog>
  );
};
